import { createContext, useContext } from 'react'
import type { TourStep } from './types'

/**
 * The tour's context object and its hook, apart from the provider.
 *
 * The provider (TourContext.tsx) imports the auth store, so any edit there
 * re-ran that module under hot reload and `createContext` minted a second
 * context: the overlay read the new one while the provider on screen still
 * held the old, and the dashboard died with "useTour must be used within
 * TourProvider". This module imports nothing that changes, so there is only
 * ever one.
 */
export interface TourContextType {
  isActive: boolean
  currentStepIndex: number
  currentStep: TourStep | null
  totalSteps: number
  startTour: () => void
  nextStep: () => void
  skipTour: () => void
  cancelTour: () => void
  resetTour: () => void
}

export const TourContext = createContext<TourContextType | null>(null)

export function useTour() {
  const ctx = useContext(TourContext)
  if (!ctx) throw new Error('useTour must be used within TourProvider')
  return ctx
}
